import {defineStore} from "pinia";
import {computed} from "vue";
import { useAgamaStore } from "@/stores/AgamaStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useGolonganStore } from "@/stores/GolonganStore";
import { usePendidikanJenjangStore } from "@/stores/PendidikanJenjangStore";
import { useArsipKategoriStore } from "@/stores/ArsipKategoriStore";
import { useStatusAktifStore } from "@/stores/StatusAktifStore";
import { useKeluargaHubStore } from "@/stores/KeluargaHubStore";
import { usePerkawinanStatusStore } from "@/stores/PerkawinanStatusStore";
import { useGajiSkemaKomponenStore } from "@/stores/GajiSkemaKomponenStore";



export const useCommonStore = defineStore(
    'commonStore',
    () => {

  
        

        async function resetStore(store) {
            // Ensure data is fetched if it's null or undefined
            if (store.data === null || store.data === undefined) {
              await store.get(); // Fetch data
            }
            return store.data; // Return the data
          }


            let arsipKategoriStore = useArsipKategoriStore().data;
        if(arsipKategoriStore === null){
            arsipKategoriStore = useArsipKategoriStore().get().data;
        }

        
        // let arsipKategoriStore =  resetStore(useArsipKategoriStore());

        let agamaStore = resetStore(useAgamaStore()); 
        let statusAktifStore = resetStore(useStatusAktifStore());
        let perkawinanStatusStore = resetStore(usePerkawinanStatusStore()); 
        let keluargaHubStore = resetStore(useKeluargaHubStore()); 
        let jabatanStore = resetStore(useJabatanStore()); 
        let cabangStore = resetStore(useCabangStore()); 
        let pendidikanJenjangStore = resetStore(usePendidikanJenjangStore()); 
        let unitStore = resetStore(useUnitStore()); 
        let pegawaiStatusStore = resetStore(usePegawaiStatusStore()); 
        let bagianStore = resetStore(useBagianStore()); 
        let subBagianStore = resetStore(useSubBagianStore()); 
        let bidangStore = resetStore(useBidangStore()); 
        let subBidangStore = resetStore(useSubBidangStore()); 
        let seksiStore = resetStore(useSeksiStore()); 
        let golonganStore = resetStore(useGolonganStore()); 
        let gajiSkemaKomponenStore = resetStore(useGajiSkemaKomponenStore()); 





      

        
        
        // const agamaStore = useAgamaStore().data;
        // const statusAktifStore = useStatusAktifStore().data;        
        // const perkawinanStatusStore = usePerkawinanStatusStore().data;
        // const keluargaHubStore = useKeluargaHubStore().data;
        // const jabatanStore = useJabatanStore().data;
        // const cabangStore = useCabangStore().data;
        // const pendidikanJenjangStore = usePendidikanJenjangStore().data;
        // const unitStore = useUnitStore().data;
        // const pegawaiStatusStore = usePegawaiStatusStore().data;
        // const bagianStore = useBagianStore().data;
        // const subBagianStore = useSubBagianStore().data;
        // const bidangStore = useBidangStore().data;
        // const subBidangStore = useSubBidangStore().data;
        // const seksiStore = useSeksiStore().data;
        // let golonganStore = useGolonganStore().data;
        // if(golonganStore === null){
        //     golonganStore = useGolonganStore().get().data;}

        const statusGajiStore = [
            {val:true, nama:'Approved'},
            {val:false, nama:'Belum Approved'},
        ];

        const jenisPengajuanStore = [
            {val:'KP', nama:'KP'},
            {val:'KGB', nama:'KGB'},
        ];

        const jenisHukumanStore = [
            {val:'Teguran Lisan', nama:'Teguran Lisan'},
            {val:'Teguran Tertulis', nama:'Teguran Tertulis'},
            {val:'Penundaan Kenaikan Gaji Berkala', nama:'Penundaan Kenaikan Gaji Berkala'},
            {val:'Penundaan Kenaikan Pangkat', nama:'Penundaan Kenaikan Pangkat'},
            {val:'Pemberhentian dengan Hormat', nama:'Pemberhentian dengan Hormat'},
            {val:'Pemberhentian dengan Tidak Hormat', nama:'Pemberhentian dengan Tidak Hormat'},
        ];

        const tingkatanPeringatanStore = [
            {val:'SP 1', nama:'SP 1'},
            {val:'SP 2', nama:'SP 2'},
            {val:'SP 3', nama:'SP 3'},
          
        ];

        const statusPengajuanStore = [
            {val:0, nama:'Diajukan'},
            {val:1, nama:'Disetujui'},
            {val:2, nama:'Ditolak'},
        ];

        const jenisPengajuanSource = computed(() => {
            return jenisPengajuanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['jenis', '=', item.val],
                };
            });
        });

        const jenisHukumanSource = computed(() => {
            return jenisHukumanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['jenis_hukuman', '=', item.val],
                };
            });
        });

        const tingkatanPeringatanSource = computed(() => {
            return jenisHukumanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['jenis_hukuman', '=', item.val],
                };
            });
        });


        const statusPengajuanSource = computed(() => {
            return statusPengajuanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status', '=', item.val],
                };
            });
        });


        const statusStore = [
            {val:true, nama:'Aktif'},
            {val:false, nama:'Tidak Aktif'},
        ];

        const statusCapegStore = [
            {val:true, nama:'80%'},
            {val:false, nama:null},
        ];

        const statusPtkpStore = [
            { nama: null },
            { nama: "TK" },
            { nama: "K0" },
            { nama: "K1" },
            { nama: "K2" },
            { nama: "K3" },
        ];

        const tipeNaikPangkatStore = [
            { nama: "Reguler" },
            { nama: "Penyesuaian" },
            { nama: "Pilihan" },
            { nama: "Pengabdian" },
        ];

        const statusJabatanStore = [
            { nama: "Definitif" },
            { nama: "Plt" },
            { nama: "Plh" },
        ];

        const jenisKelaminStore = [
            { nama: "L" },
            { nama: "P" },
        ];
       
        const statusPenyesuaianStore = [
            {val:true, nama:'Penyesuaian'},
            {val:false, nama:null},
        ];

        const statusTertanggungStore = [
            {val:true, nama:'Tertanggung'},
            {val:false, nama:null},
        ];
       

        const jabatanSource = computed(() => {
            return jabatanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['jabatans_nama', '=', item.nama],
                };
            });
        });

       

        const keluargaHubSource = computed(() => {
            return keluargaHubStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['keluarga_hubs_nama', '=', item.nama],
                };
            });
        });
        const pendidikanJenjangSource = computed(() => {
            return pendidikanJenjangStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['pendidikan_jenjang_id', '=', item.id],
                };
            });
        });

        const perkawinanStatusSource = computed(() => {
            return perkawinanStatusStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['perkawinan_statuses_nama', '=', item.nama],
                };
            });
        });

        const statusSource = computed(() => {
            return statusStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status', '=', item.val],
                };
            });
        });

        const statusCapegSource = computed(() => {
            return statusCapegStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status', '=', item.val],
                };
            });
        });

        const statusPtkpSource = computed(() => {
            return statusPtkpStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status_ptkp', '=', item.nama],
                };
            });
        });

        const tipeNaikPangkatSource = computed(() => {
            return tipeNaikPangkatStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['simpeg_naik_pangkats_tipe', '=', item.nama],
                };
            });
        });

        const statusJabatanSource = computed(() => {
            return statusJabatanStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status_jabatan', '=', item.nama],
                };
            });
        });

        const jenisKelaminSource = computed(() => {
            return jenisKelaminStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['jenis_kelamin', '=', item.nama],
                };
            });
        });

        const statusAktifSource = computed(() => {
            return statusAktifStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status_aktifs_nama', '=', item.nama],
                };
            });
        });

      

      




        const statusGajiSource = computed(() => {
            return statusGajiStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['gajis_status_gaji', '=', item.val],
                };
            });
        });

        const statusPenyesuaianSource = computed(() => {
            return statusPenyesuaianStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status_penyesuaian', '=', item.val],
                };
            });
        });

        const statusTertanggungSource = computed(() => {
            return statusTertanggungStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['status_tertanggung', '=', item.val],
                };
            });
        });


        const golonganSource = computed(() => {
            return golonganStore.map((item) => {
                return {
                    text: item.nama,
                    // value: ['golongans_nama', '=', item.nama],
                    value: ['golongans_id', '=', item.id],
                };
            });
        });

        const golonganNaikPangkatsSource = computed(() => {
            return golonganStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['golongan_naik_pangkats_nama', '=', item.nama],
                };
            });
        });

        const golonganPrediksisSource = computed(() => {
            return golonganStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['golongan_prediksis_nama', '=', item.nama],
                };
            });
        });



       

       


        const cabangSource = computed(() => {
            return cabangStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['cabangs_nama', '=', item.nama],
                };
            });
        });


        const unitSource = computed(() => {
            return unitStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['units_nama', '=', item.nama],
                };
            });
        });



        const pegawaiStatusSource = computed(() => {
            return pegawaiStatusStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['pegawai_statuses_nama', '=', item.nama],
                };
            });
        });

        function getPegawaiStatusSource(variablePassed = null) {
            return computed(() => {
                return pegawaiStatusStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['pegawai_status_id', '=', item.id]
                            : ['pegawai_statuses_nama', '=', item.nama],
                    };
                });
            });
        }


        


        const bagianSource = computed(() => {
            return bagianStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['bagians_nama', '=', item.nama],
                };
            });
        });

        const subBagianSource = computed(() => {
            return subBagianStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['sub_bagians_nama', '=', item.nama],
                };
            });
        });


        const bidangSource = computed(() => {
            return bidangStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['bidangs_nama', '=', item.nama],
                };
            });
        });


        const subBidangSource = computed(() => {
            return subBidangStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['sub_bidangs_nama', '=', item.nama],
                };
            });
        });


        const seksiSource = computed(() => {
            return seksiStore.map((item) => {
                return {
                    text: item.nama,
                    value: ['seksis_nama', '=', item.nama],
                };
            });
        });

       
      
      
        
       
        
            const agamaSource = computed(() => {
                return agamaStore.map((item) => {
                    return {
                        text: item.nama,
                        value: ['agamas_nama', '=', item.nama],
                    };
                });
            });
       
           

            function getGolonganSource(variablePassed = null) {
                return computed(() => {
                    return golonganStore.map((item) => {
                        return {
                            text: item.nama,
                            value: variablePassed === 'crud'
                                ? ['golongan_id', '=', item.id]
                                : ['golongans_nama', '=', item.nama],
                        };
                    });
                });
            }


           

            
            function getTipeNaikPangkatSource(variablePassed = null) {
                return computed(() => {
                    return tipeNaikPangkatStore.map((item) => {
                        return {
                            text: item.nama,
                            value: variablePassed === 'crud'
                                ? ['tipe', '=', item.nama] //tidak punya id
                                : ['simpeg_naik_pangkats_tipe', '=', item.nama],
                        };
                    });
                });
            }

          

            function getJabatanSource(variablePassed = null) {
                return computed(() => {
                    return jabatanStore.map((item) => {
                        return {
                            text: item.nama,
                            value: variablePassed === 'crud'
                                ? ['jabatan_id', '=', item.id] //tidak punya id
                                : ['jabatans_nama', '=', item.nama],
                        };
                    });
                });
            }


            
          

            function getCabangSource(variablePassed = null) {
                return computed(() => {
                    return cabangStore.map((item) => {
                        return {
                            text: item.nama,
                            value: variablePassed === 'crud'
                                ? ['cabang_id', '=', item.id] //tidak punya id
                                : ['cabangs_nama', '=', item.nama],
                        };
                    });
                });
            }


        function getUnitSource(variablePassed = null) {
            return computed(() => {
                return unitStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['unit_id', '=', item.id] //tidak punya id
                            : ['units_nama', '=', item.nama],
                    };
                });
            });
        }

        function getBagianSource(variablePassed = null) {
            return computed(() => {
                return bagianStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['bagian_id', '=', item.id] //tidak punya id
                            : ['bagians_nama', '=', item.nama],
                    };
                });
            });
        }

        function getSubBagianSource(variablePassed = null) {
            return computed(() => {
                return subBagianStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['sub_bagian_id', '=', item.id] //tidak punya id
                            : ['sub_bagians_nama', '=', item.nama],
                    };
                });
            });
        }

        function getBidangSource(variablePassed = null) {
            return computed(() => {
                return bidangStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['bidang_id', '=', item.id] //tidak punya id
                            : ['bidangs_nama', '=', item.nama],
                    };
                });
            });
        }

        function getSubBidangSource(variablePassed = null) {
            return computed(() => {
                return subBidangStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['sub_bidang_id', '=', item.id] //tidak punya id
                            : ['sub_bidangs_nama', '=', item.nama],
                    };
                });
            });
        }

        function getSeksiSource(variablePassed = null) {
            return computed(() => {
                return seksiStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['seksi_id', '=', item.id] //tidak punya id
                            : ['seksis_nama', '=', item.nama],
                    };
                });
            });
        }

        function getPendidikanJenjangSource(variablePassed = null) {
            return computed(() => {
                return pendidikanJenjangStore.map((item) => {
                    return {
                        text: item.nama,
                          value: variablePassed === null
                            ? ['pendidikan_jenjangs_nama', '=', item.nama]
                            : variablePassed === 'crud'
                                ? ['pendidikan_jenjang_id', '=', item.id]
                                : ['riwayat_pendidikans_pendidikan_jenjang_nama', '=', item.nama],
                        // value: variablePassed === 'crud'
                        //     ? ['pendidikan_jenjang_id', '=', item.id] //tidak punya id
                        //     : ['pendidikan_jenjangs_nama', '=', item.nama],
                    };
                });
            });
        }




        function getKeluargaHubSource(variablePassed = null) {
            return computed(() => {
                return keluargaHubStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['keluarga_hub_id', '=', item.id] //tidak punya id
                            : ['keluarga_hubs_nama', '=', item.nama],
                    };
                });
            });
        }




        function getPerkawinanStatusSource(variablePassed = null) {
            return computed(() => {
                return perkawinanStatusStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['perkawinan_status_id', '=', item.id] //tidak punya id
                            : ['perkawinan_statuses_nama', '=', item.nama],
                    };
                });
            });
        }

   

        function getAgamaSource(variablePassed = null) {
            return computed(() => {
                return agamaStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['agama_id', '=', item.id] //tidak punya id
                            : ['agamas_nama', '=', item.nama],
                    };
                });
            });
        }

        function getArsipKategoriSource(variablePassed = null) {
            return computed(() => {
                return arsipKategoriStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['arsip_kategori_id', '=', item.id] //tidak punya id
                            : ['arsip_kategoris_nama', '=', item.nama],
                    };
                });
            });
        }

        function getPegawaiSource(pegawaiStore, variablePassed = null) {
            return computed(() => {
                return pegawaiStore.map((item) => {
                    return {
                        text: item.nama,
                        value: variablePassed === 'crud'
                            ? ['arsip_pegawais_pegawai_ids', '=', item.id] //tidak punya id
                            : ['pegawai_id', '=', item.id], //filtering from pengajuan-list
                    };
                });
            });
        }

       



        return {
            getGolonganSource,
            getTipeNaikPangkatSource,
            agamaSource,
            jabatanStore,
            jabatanSource,
            cabangStore,
            cabangSource,
            unitStore,
            unitSource,
            pegawaiStatusStore,
            pegawaiStatusSource,
            bagianStore,
            bagianSource,
            subBagianStore,
            subBagianSource,
            bidangStore,
            bidangSource,
            subBidangStore,
            subBidangSource,
            seksiStore,
            seksiSource,
            golonganStore,
            golonganSource,
            statusGajiStore,
            statusGajiSource,
            arsipKategoriStore,
           
            statusAktifSource,
            statusPtkpStore,
            statusPtkpSource,
            jenisKelaminStore,
            jenisKelaminSource,
            tipeNaikPangkatSource,
            tipeNaikPangkatStore,
            statusStore,
            statusSource,
            statusPenyesuaianStore,
            statusPenyesuaianSource,
            pendidikanJenjangStore,
            pendidikanJenjangSource,
            golonganNaikPangkatsSource,
            golonganPrediksisSource,
            keluargaHubStore,
            keluargaHubSource,
            perkawinanStatusStore,
            perkawinanStatusSource,
            statusTertanggungSource,
            statusCapegStore,
            statusCapegSource,
            statusJabatanStore,
            statusJabatanSource,
            getPegawaiStatusSource,
            getJabatanSource,
            getCabangSource,
            getUnitSource,
            getBagianSource,   
            getSubBagianSource,
            getBidangSource,
            getSubBidangSource,
            getSeksiSource,
            getPendidikanJenjangSource,
            getKeluargaHubSource,
            statusTertanggungStore,
            getPerkawinanStatusSource,
            getAgamaSource,
            agamaStore,
            statusAktifStore,
            getArsipKategoriSource,
            getPegawaiSource,
            jenisPengajuanStore,
            jenisPengajuanSource,
            
            jenisHukumanStore,
            jenisHukumanSource,
            tingkatanPeringatanStore,
            tingkatanPeringatanSource,

            statusPengajuanStore,
            statusPengajuanSource,
            gajiSkemaKomponenStore,
        }
    });